<template>
  <pl-dialog
    :title="`Disconnect your ${integration.name} account?`"
    :size="'md'"
    :disableOutsideClick="true"
    @close="closeModal"
  >
    <main class="flex flex-grow center items-center p-5">
      <div
        class="flex center items-center"
        style="flex-direction: column; font-size: 16px"
      >
        <span v-if="getProfile.role === 'teacher'">
          This action will disconnect your current connected
          {{ integration.name }} account from your Parlay Courses. If you want
          to share roster / assignment / assessment data between
          {{ integration.name }} and Parlay in the future, you will have to
          reconnect your account.
        </span>
        <span v-else>
          This action will disconnect your current connected
          {{ integration.name }} account from your Parlay Courses. If your
          teacher connects your Parlay class to a {{ integration.name }} class
          in the future, you will have to reconnect your account.
        </span>
        <pl-spinner v-if="loading" />
        <span v-else class="my-3 font-bold">
          {{ profile.email }}
        </span>
      </div>
    </main>
    <footer class="flex center items-center my-5">
      <button
        class="mx-5 px-10 py-2 w-40 hover:bg-gray-200 rounded cursor-pointer text-gray-400 :hover:text-gray-500 font-semibold disabled:opacity-50"
        @click="closeModal"
      >
        Cancel
      </button>
      <button
        class="mx-5 px-10 py-2 w-40 bg-red-300 hover:bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50"
        @click="disconnectAccount"
      >
        Disconnect
      </button>
    </footer>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';

  export default {
    data() {
      return {
        removeStudents: false,
        loading: false,
        profile: {},
      };
    },
    props: {
      integration: {
        type: Object,
        default: '',
      },
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getRoleInCourse',
        'getCourseLayoutFullScreenStatus',
        'getProfile',
      ]),
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      disconnectAccount() {
        return this.integration.name === 'Google Classroom'
          ? this.disconnectClassroomAccount()
          : this.disconnectIntegrationAccount();
      },
      disconnectClassroomAccount() {
        this.$store
          .dispatch('disconnectClassroomIntegrationAccount')
          .then(() => {
            this.closeModal();
          })
          .catch((err) => {
            console.error(err);
          });
      },
      disconnectIntegrationAccount() {
        const integration_id = this.integration.integration_id;
        this.$store
          .dispatch('disconnectSsoIntegration', {
            integration_id,
          })
          .then(() => {
            EventBus.$emit('disconnected-integration-account', integration_id);
            this.closeModal();
            this.$store.dispatch('removeUserFromClassesSharingRule', {
              integration_id: integration_id,
              payload: {
                user_id: this.profile.user_id,
                email: this.profile.email,
              },
            });
          })
          .catch((err) => {
            this.loading_to_disconnect = false;
            console.error(err);
          });
      },
    },
    async created() {
      if (this.integration.name === 'Google Classroom') {
        this.profile = this.getProfile.google_integration;
      } else {
        const user_integration = this.getProfile.edlink_integrations.find(
          (x) => x.id === this.integration.integration_id
        );
        if (user_integration) {
          if (user_integration.email && user_integration.name) {
            this.profile = {
              user_id: user_integration.user_id,
              name: user_integration.name,
              email: user_integration.email,
            };
          } else {
            this.loading = true;
            const { data } = await adminServices.getSsoIntegrationProfile(
              this.integration.integration_id
            );
            this.loading = false;
            if (data) {
              this.profile = data;
            }
          }
        }
      }
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// profileDisconnectIntegrationModal.vue?5a6d4f0a